import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';

import { HeaderComponent } from './header.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { CountUpModule } from 'ngx-countup';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NotificationCenterModule } from '@shared/notification-center/notification-center.module';
import { ElearnioLanguageSpanModule } from '@shared/elearnio-language-icon/elearnio-language-span.module';
import { LanguageSelectorModule } from '@shared/language-selector/language-selector.module';

export const declarations = [HeaderComponent];

export const imports = [
  MatButtonModule,
  MatIconModule,
  MatDividerModule,
  MatMenuModule,
  MatToolbarModule,
  TranslateModule,
  MatBadgeModule,
  CountUpModule,
  FlexLayoutModule,
  MatDialogModule,
  NotificationCenterModule,
  ElearnioLanguageSpanModule,
  LanguageSelectorModule,
];

@NgModule({
  declarations,
  imports: [CommonModule, RouterModule, ...imports],
  exports: [...declarations],
})
export class HeaderModule {}
